(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_filter_by_tag_wrapper"] && !Shopify.designMode) return;
  try {
    // filter group toggle
    document.querySelectorAll('.filter-group').forEach(function (el) {
      el.querySelector('.filter-name').addEventListener('click', function () {
        const list = el.querySelector('.filter-list');
        list.classList.toggle('active');
        const height = list.scrollHeight;
        list.style.height = list.classList.contains('active') ? height + 'px' : '0';
        list.style.marginBottom = list.classList.contains('active') ? '1.5rem' : '0';
      });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('HeaderMenuActivated', function () {
  const links = document.querySelectorAll(".shopify-block.mega_link");
  const menuItems = document.querySelectorAll("overflow-list > li");

  menuItems.forEach((item) => {
    const title = item.querySelector(".menu-list__link-title")?.textContent.trim().toLowerCase();
    if (!title) return;

    const submenuInner = item.querySelector(".menu-list__submenu-inner");
    if (!submenuInner) return;

    let wrapper = submenuInner.querySelector(".blocks-wrapper");
    if (!wrapper) {
      wrapper = document.createElement("div");
      wrapper.classList.add("blocks-wrapper");
      submenuInner.append(wrapper);
    }

    links.forEach((link) => {
      const inner = link.querySelector(".mega-inner");
      const toggle = inner?.getAttribute("aria-toggle")?.trim();
      const subtoggle = inner?.getAttribute("aria-subtoggle")?.trim();

      if (!toggle || !subtoggle) return;
      if (title !== toggle) return;

      if (!wrapper.contains(link)) {
        wrapper.append(link);
      }

      const subLinks = Array.from(item.querySelectorAll(".mega-menu__link"));

      subLinks.forEach((a) => {
        const text = a.textContent.trim();

        if (text === subtoggle) {
          a.setAttribute("aria-toggle-content", toggle);
          a.setAttribute("aria-subtoggle-content", subtoggle);
          a.classList.add("has-toggle");
        }
      });

      item.querySelector(".menu-list__submenu")?.classList.add(
        "has-toggle-content",
        "section",
        "section--page-width"
      );
    });

    // ✅ 默认展开当前 submenu 里的第一个 mega-inner
    const submenu = item.querySelector(".menu-list__submenu");

    if (submenu) {
      const allInners = submenu.querySelectorAll(".mega-inner");
      const allToggleLinks = submenu.querySelectorAll(".mega-menu__link.has-toggle");

      allInners.forEach(inner => inner.classList.remove("active"));
      allToggleLinks.forEach(a => a.classList.remove("active"));

      const firstInner = allInners[0];

      if (firstInner) {
        firstInner.classList.add("active");

        const firstSubtoggle = firstInner.getAttribute("aria-subtoggle")?.trim();

        if (firstSubtoggle) {
          const firstLink = Array.from(allToggleLinks).find(a => {
            return a.getAttribute("aria-subtoggle-content")?.trim() === firstSubtoggle;
          });

          firstLink?.classList.add("active");
        }

        requestAnimationFrame(() => {
          const submenuHeight = Math.max(firstInner.offsetHeight, submenu.offsetHeight);
          const parentMenu = submenu.closest("header-menu");

          if (parentMenu) {
            parentMenu.style.setProperty("--submenu-height", `${submenuHeight}px`);
          }
        });
      }
    }
  });

  document.querySelectorAll('.mega-menu__link.has-toggle').forEach(link => {
    link.addEventListener('mouseenter', function (e) {
      e.preventDefault();

      const subtoggle = this.getAttribute('aria-subtoggle-content')?.trim();
      const submenu = this.closest('.menu-list__submenu');

      if (!submenu || !subtoggle) return;

      let toggleContentOffsetHeight = 0;

      submenu.querySelectorAll('.mega-inner').forEach(inner => {
        inner.classList.remove('active');
      });

      submenu.querySelectorAll('.mega-menu__link.has-toggle').forEach(a => {
        a.classList.remove('active');
      });

      this.classList.add('active');

      const targetInner = submenu.querySelector(`.mega-inner[aria-subtoggle="${subtoggle}"]`);

      if (targetInner) {
        targetInner.classList.add('active');
        toggleContentOffsetHeight = targetInner.offsetHeight;
      }

      requestAnimationFrame(() => {
        const submenuHeight = Math.max(toggleContentOffsetHeight, submenu.offsetHeight);
        const parentMenu = submenu.closest('header-menu');

        if (parentMenu) {
          parentMenu.style.setProperty('--submenu-height', `${submenuHeight}px`);
        }
      });
    });
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["localization"] && !Shopify.designMode) return;
  try {
    class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.localization-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
  } catch(e) { console.error(e); }
})();

})();
